import "moment/locale/ru";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import moment from "moment";
import { initReactI18next } from "react-i18next";

import { PickerLocale } from "antd/lib/date-picker/generatePicker";
import dataPickerConfigEN from "antd/lib/date-picker/locale/en_US";
import dataPickerConfigRU from "antd/lib/date-picker/locale/ru_RU";

import enTranslations from "./locales/en";
import ruTranslations from "./locales/ru";

export const LS_LANGUAGE_KEY = "LANGUAGE";

export const RUSSIAN_LANGUAGE = "ru";
export const ENGLISH_LANGUAGE = "en";

export const availableLanguages = [
  {
    code: RUSSIAN_LANGUAGE,
    icon: "🇷🇺",
    dataPickerConfig: dataPickerConfigRU,
  },
  {
    code: ENGLISH_LANGUAGE,
    icon: "🇬🇧",
    dataPickerConfig: dataPickerConfigEN,
  },
];

export const languageIconMap: Record<string, string> = availableLanguages.reduce((obj, { code, icon }) => {
  return { ...obj, [code]: icon };
}, {});

export const languageDataPickerConfigMap: Record<string, PickerLocale> = availableLanguages.reduce(
  (obj, { code, dataPickerConfig }) => {
    return { ...obj, [code]: dataPickerConfig };
  },
  {}
);

const resources = {
  en: enTranslations,
  ru: ruTranslations,
};

i18n.on("initialized", (options) => {
  moment.locale(options.lng);
});

i18n.on("languageChanged", (lng) => {
  moment.locale(lng);
});

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: ENGLISH_LANGUAGE,
    supportedLngs: Object.keys(languageIconMap),
    debug: process.env.NODE_ENV !== "production",
    react: {
      useSuspense: false,
    },
    detection: {
      lookupLocalStorage: LS_LANGUAGE_KEY,
    },
    resources,
  });

export default i18n;
